import { useOutletContext } from "react-router-dom"
import { useMemo } from "react"
import { PLAN_USER_ROLE } from "../constants/planUserRole"
import { useAtom } from "jotai"
import { userAtom } from "../state"

export const usePlanRoles = () => {
  const { plan } = useOutletContext()
  const [user] = useAtom(userAtom)

  const roles = useMemo(() => plan?.current_user_role ?? [], [plan])

  // Check actual plan membership by looking at user relationships, not computed roles
  const isActualPlanMember = useMemo(() => {
    if (!plan || !user) return false

    const userId = user.id
    const mentors = (plan.mentors ?? []).map(m => m.id)
    const guides = (plan.guide ?? []).map(g => g.id)
    const youth = (plan.youth ?? []).map(y => y.id)
    const initiators = (plan.initiator ?? []).map(i => i.id)
    const guardians = (plan.guardians ?? []).map(g => g.id)

    return mentors.includes(userId) ||
           guides.includes(userId) ||
           youth.includes(userId) ||
           initiators.includes(userId) ||
           guardians.includes(userId)
  }, [plan, user])

  const isNotPlanMember = useMemo(() => !isActualPlanMember, [isActualPlanMember])
  const isInitiator = useMemo(() => roles.includes(PLAN_USER_ROLE.INITIATOR), [roles])
  const isGuide = useMemo(() => roles.includes(PLAN_USER_ROLE.GUIDE), [roles])
  const isMentor = useMemo(() => roles.includes(PLAN_USER_ROLE.MENTOR), [roles])
  const isStudent = useMemo(() => roles.includes(PLAN_USER_ROLE.YOUTH), [roles])
  const isGuardian = useMemo(() => roles.includes(PLAN_USER_ROLE.GUARDIAN), [roles])

  return { isNotPlanMember, isInitiator, isGuide, isMentor, isStudent, isGuardian, isActualPlanMember }
}